export default () => {
    const cards = document.querySelectorAll('.wlpbCard');
    cards.forEach(card => {
        card.addEventListener('click', () => {
            const radio = card.querySelector('input[type="radio"]');
            radio.click();
            document.body.dispatchEvent(new Event('wlpbCardClicked'));
        });
    });

    document.body.addEventListener('wlpbCardClicked', () => {
        cards.forEach(card => {
            const radio = card.querySelector('input[type="radio"]');

            card.classList.remove('active');
            if(radio.checked) card.classList.add('active');
        });
    });
}